import {SET_CURRENT_USER, SET_INSTALLER, CLEAR_CURRENT_PROFILE, UPDATE_INSTALLER} from '../actions/types';
import isEmpty from '../validation/is-empty';

const initialState = {
    isAuthenticated: false,
    user: {},
    installer: null
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: action.payload
            };
        case SET_INSTALLER:
            return {
                ...state,
                installer: action.payload
            }
        case UPDATE_INSTALLER:
            return {
                ...state,
                installer: action.payload.data.partner_shop
            }
        case CLEAR_CURRENT_PROFILE:
            return {
                ...state,
                isAuthenticated:false,
                user: {},
                installer: null
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.jsx